<template>
    <div class="symptom-manifestation">
        <div class="chart-row">
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">{{ stackedTitle }}</p>
                <disease-chart :option="stackedOption" height="360px" />
            </div>
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">{{ graphTitle }}</p>
                <disease-chart :option="graphOption" height="360px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import symptomManifestationData from '../mock/symptomManifestation.json';

const STACK_COLORS = ['#448EF6', '#1EB273', '#F39C12', '#8E44AD', '#E91E63', '#00BCD4', '#F44336'];

function buildStackedOption(stacked) {
    const xAxis = stacked.xAxis || [];
    const seriesList = stacked.series || [];
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
        },
        legend: {
            bottom: 0,
            data: seriesList.map((item) => item.name),
            textStyle: { color: '#5A6779', fontSize: 11 },
        },
        grid: {
            left: 16,
            right: 16,
            top: 16,
            bottom: 36,
            containLabel: true,
        },
        xAxis: {
            type: 'category',
            data: xAxis,
            axisTick: { show: false },
            axisLine: { lineStyle: { color: '#E8EEF8' } },
            axisLabel: {
                color: '#333',
                fontSize: 12,
                interval: 0,
                rotate: 20,
            },
        },
        yAxis: {
            type: 'value',
            splitLine: { lineStyle: { type: 'dashed', color: '#E8EEF8' } },
            axisLabel: { color: '#5A6779' },
        },
        series: seriesList.map((item, index) => ({
            name: item.name,
            type: 'bar',
            stack: 'total',
            barWidth: 28,
            emphasis: { focus: 'series' },
            itemStyle: {
                color: STACK_COLORS[index % STACK_COLORS.length],
            },
            data: item.data || [],
        })),
    };
}

function buildGraphOption(graph) {
    const categories = graph.categories || [];
    const nodes = graph.nodes || [];
    const links = graph.links || [];
    return {
        tooltip: { trigger: 'item' },
        legend: {
            data: categories.map((item) => item.name),
            bottom: 0,
            textStyle: { color: '#5A6779', fontSize: 11 },
        },
        series: [
            {
                type: 'graph',
                layout: 'force',
                roam: true,
                draggable: true,
                legendHoverLink: false,
                categories,
                data: nodes,
                links,
                label: {
                    show: true,
                    color: '#333',
                    fontSize: 11,
                },
                lineStyle: {
                    color: 'source',
                    curveness: 0.15,
                    opacity: 0.6,
                },
                force: {
                    repulsion: 260,
                    edgeLength: [40, 110],
                    gravity: 0.08,
                },
                emphasis: {
                    focus: 'adjacency',
                    lineStyle: { width: 3 },
                },
            },
        ],
    };
}

export default {
    name: 'SymptomManifestation',
    components: {
        DiseaseChart,
    },
    data() {
        return {
            chartData: symptomManifestationData,
        };
    },
    computed: {
        stackedTitle() {
            return (this.chartData.stacked && this.chartData.stacked.title) || '柱状堆积图';
        },
        graphTitle() {
            return (this.chartData.graph && this.chartData.graph.title) || '知识图谱';
        },
        stackedOption() {
            return buildStackedOption(this.chartData.stacked || {});
        },
        graphOption() {
            return buildGraphOption(this.chartData.graph || { categories: [], nodes: [], links: [] });
        },
    },
};
</script>

<style lang="less" scoped>
.symptom-manifestation {
    .chart-row {
        display: flex;
        gap: 16px;
        align-items: stretch;
    }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;

        &.w-1-2 {
            flex: 1 1 0;
        }
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
